import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import IMAGES from "@/data/images";
import { DURATION, EASE } from "@/lib/motion";

export const LocationCard = ({ location, index = 0 }) => {
  const reduce = useReducedMotion();
  const img = IMAGES[location.image] || IMAGES.heroRidge;

  return (
    <motion.div
      initial={{ opacity: 0, y: reduce ? 0 : 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: DURATION.editorial, ease: EASE.editorial, delay: Math.min(index * 0.07, 0.35) }}
      className="group"
      data-testid={`location-card-${location.slug}`}
    >
      <Link to={`/locations/${location.slug}`} className="block">
        <div className="ss-hover-grow relative overflow-hidden aspect-[3/4] bg-[#EFECE6]">
          <img src={img.url} alt={img.alt} loading="lazy" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#181A1B]/75 via-transparent to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-6">
            <p className="font-mono-ss text-[0.64rem] tracking-widest text-[#F7F5F0]/70 mb-2">{location.coords}</p>
            <h3 className="font-display text-3xl font-light text-[#F7F5F0] leading-none">{location.name}</h3>
            <div className="mt-3 flex items-center justify-between">
              <span className="text-[0.72rem] uppercase tracking-[0.1em] text-[#F7F5F0]/70">{location.region}</span>
              <ArrowUpRight className="h-5 w-5 text-[#F7F5F0] transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.3} />
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default LocationCard;
